<div class="modal-header">
    <h4 class="modal-title" id="labelButtons">Claim AZ MVD Now Account</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>

    <h2>This customer has not claimed their AZ MVD Now account.</h2>
    <p>
        If the account is not claimed, the customer will be forced to complete additional authentication when activating their AZ MVD Now Account in the future.
    </p>
    <form *ngIf="showRestrict" [formGroup]="form">
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label class="required">Reason</label>
                <select class="mvd_form-control" formControlName="denialReasonTypeId" trim="blur">
                    <option></option>
                    <option *ngFor="let reason of denialReasons" [ngValue]="reason.id">{{reason.azmvdNowClaimAccountDenialReasonTypeDisplayValue}}</option>
                </select>
                <control-validation-messages control="denialReasonTypeId" [formGroup]="form"></control-validation-messages>
            </div>
            <div class="col-sm-12 mvd_form-group" *ngIf="form.value.denialReasonTypeId == denialReasonEnum.Other.id">
                <label class="required">Reason Description</label>
                <textarea class="mvd_form-control" formControlName="denialReasonDescription" type="text" trim="blur" maxlength="512" rows="10"></textarea>
                <control-validation-messages control="denialReasonDescription" [formGroup]="form"></control-validation-messages>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <div class="btn--group">
        <ng-container *ngIf="showRestrict; else elseBlock">
            <button class="btn--default" type="button" (click)="back()">Back</button>
            <mvm-spinner-btn [isLoading]="inProgress" [btnClass]="'btn--primary'" [btnText]="'Done'" [isDisabled]="!form.valid" (clicked)="submit()"></mvm-spinner-btn>            
        </ng-container>
        <ng-template #elseBlock>
            <button class="btn--default" type="button" (click)="beginRestrict()">Restrict Account</button>
            <button class="btn--primary" type="button" (click)="goToClaimAccount()">Claim Account</button>
        </ng-template>
    </div>
</div>
